import { isValidMomentDate } from './OperatorValidators';
import { makeOperator } from './Operator';
import { MomentDateWithTime } from '../DisplayTypes';
export default makeOperator({
  displayType: MomentDateWithTime,
  name: 'BeforeTimePointWithTime',
  values: [{
    name: 'value',
    isValid: isValidMomentDate
  }]
});